import React, { useRef, useState, useEffect } from 'react'
import {
  Box,
  Text,
  IcoMoon,
  CancelIcon,
  PlusIcon,
} from '@usap/uicomponents'
import { Heading5 } from '../../../../common/heading'
import useWmoEnabled from '@usap/carparts/src/shared/hooks/useWmoEnabled'
import DiagnosisWMO from './DiagnosisWMO'

const Diagnosis = ({
  onChange,
  removeDocument,
  formFile = {},
  errorSteps = {},
  widget,
  selectedPart,
  isDesktop
}) => {
  const {
    id,
    required,
    props: curProps = [],
    title = 'Upload Diagnostic Document',
    subtitle = "It's highly recommended to provide a diagnostic test results of your Catalytic Converter from your mechanic. This can help us expedite the return process.",
  } = widget

  const isWmoEnabled = useWmoEnabled()

  const fileInputs = useRef({})
  const requiredData = required
    ? ''
    : '<em style="font-size: 12px;font-weight: normal">(Optional)</em>'
  const maxThreshold = 3
  const [maxFiles, setMaxFiles] = useState(false)
  const [fileInputId, setFileInputId] = useState('')

  const filteredPropsWithFormFile = curProps.filter(x => formFile[x.id])
  const filteredPropsWithoutFormFile = curProps.filter(x => typeof formFile[x.id] === 'undefined')
  const organizedWidgets = [
    ...filteredPropsWithFormFile,
    ...filteredPropsWithoutFormFile,
  ]

  useEffect(() => {
    const uploadedDocsCount = curProps.filter(x => formFile[x.id]).length || 0

    if (uploadedDocsCount === maxThreshold) {
      setMaxFiles(true)
    } else {
      setMaxFiles(false)
    }
  }, [formFile, curProps])

  useEffect(() => {
    const fileInputForUploadId = filteredPropsWithoutFormFile.length > 0 ? filteredPropsWithoutFormFile[0].id : 'noId'
    setFileInputId(fileInputForUploadId)
  }, [filteredPropsWithoutFormFile])

  if(isWmoEnabled) {
    return (
      <DiagnosisWMO 
        onChange={onChange}
        removeDocument={removeDocument}
        formFile={formFile}
        errorSteps={errorSteps}
        widget={widget}
        selectedPart={selectedPart}
        isDesktop={isDesktop}
        organizedWidgets={organizedWidgets}
        maxFiles={maxFiles}
        fileInputId={fileInputId}
      />
    )
  }

  return (
    <Box
      margin={{ bottom: '24px' }}
      key={id}
    >
      {isWmoEnabled ?
        <Heading5
          title={`${title} ${requiredData}`}
          width="large"
          size="medium"
          color="dark-2"
          style={{ fontSize: isDesktop ? '16px' : '14px', fontWeight: 600, maxWidth: '100%' }}
          margin={{ bottom: '8px', top: '0px' }}
        />
        : 
        <Heading5
          title={`${title} ${requiredData}`}
          width="large"
          size="medium"
          color="#000"
          style={{ fontSize: '14px', fontWeight: 700, maxWidth: '100%' }}
          margin={{ bottom: '8px' }}
        />
      }
      <Text id={`error-${id}`} style={{ color: '#f90000', fontSize: '12px' }}>
        {errorSteps[`${id}`]}
      </Text>
      <Text size="small" margin="small">
        {subtitle}
      </Text>

      { organizedWidgets.map(prop => (
        <>
          { formFile[prop.id] && (
            <Box
              key={`${id}-${prop.id}`}
              width="100%"
              style={{
                background: '#f5f5f5',
                textAlign: 'center',
                padding: '8px',
                position: 'relative',
                borderRadius: '6px',
                marginBottom: '8px',
              }}
            >
              <Text style={{
                userSelect: 'none',
                padding: '0px 8px',
                textAlign: 'left',
              }}
              >
                {formFile[`${prop.id}`].content.name || ''}
              </Text>
              <IcoMoon
                icon={CancelIcon}
                color="#666"
                size="small"
                style={{
                  position: 'absolute',
                  float: 'right',
                  right: '4px',
                  cursor: 'pointer',
                }}
                onClick={() => {
                  removeDocument(prop.id, widget, selectedPart)
                }}
              />
            </Box>
          )}
          { !formFile[prop.id] && (
            <input
              accept=".jpg, .jpeg, .gif, .png, .bmp, .docx, .doc, .pdf"
              ref={ref => { fileInputs.current[`${prop.id}`] = ref }}
              name={selectedPart}
              widgetreq={required ? 'true' : ''}
              id={prop.id}
              type="file"
              onChange={onChange}
              style={{ visibility: 'hidden', width: '1px', height: '1px' }}
            />
          )}
        </>
      ))}
      { !maxFiles && (
        <Box
          width="100%"
          style={{
            background: '#f5f5f5',
            fontSize: '14px',
            textAlign: 'center',
            alignSelf: 'center',
            padding: '4pt 0px',
            cursor: 'pointer',
            margin: '8px 0px',
            borderRadius: '6px',
          }}
          onClick={() => {
            fileInputs.current[`${fileInputId}`].click()
          }}
        >
          <IcoMoon
            icon={PlusIcon}
            color="#05629b"
            size="42px"
            style={{
              alignSelf: 'center',
              marginLeft: '8px',
            }}
          />
          <Text size="small" style={{ color: '#05629b' }}>
            Add File
          </Text>
        </Box>
      )}
    </Box>
  )
}

export default Diagnosis
